var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellTrans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    clipPath: "url(#clip0_1592_849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 74214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4518 17.8805C19.6139 17.3669 19.035 16.5053 18.8352 15.5259L17.5742 9.33393C16.9896 6.2912 14.3799 4.06494 11.3173 4.06494C8.25461 4.06494 5.64533 6.2912 5.06028 9.33393L3.80253 15.5092C3.60194 16.4936 3.02464 17.364 2.18274 17.8805C1.47416 18.3146 1 19.1085 1 20.0165C1 20.9315 1.49169 21.7179 2.21535 22.1425C2.57698 22.3547 2.99039 22.4563 3.40706 22.4563H19.214C19.83 22.4563 20.4302 22.2273 20.8794 21.7952C21.3516 21.3419 21.6435 20.6992 21.6337 19.981C21.6215 19.088 21.1506 18.3092 20.4514 17.8805H20.4518Z",
    stroke: "#094E60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.90869 22.4585C8.42973 23.9435 9.75843 24.9998 11.3175 24.9998C12.8777 24.9998 14.2072 23.9422 14.7279 22.4556L7.90869 22.4585Z",
    stroke: "#094E60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.70601 4.27588C9.45935 3.9345 9.31299 3.51165 9.31299 3.05411C9.31299 1.91967 10.2103 1 11.3172 1C12.4241 1 13.3215 1.91967 13.3215 3.05411C13.3215 3.51165 13.1755 3.9345 12.9285 4.2763",
    stroke: "#094E60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.2284 11.1267C22.7591 9.55789 22.7591 7.01438 21.2284 5.44559C19.6976 3.8768 17.2159 3.8768 15.6852 5.44559C14.1545 7.01438 14.1545 9.55789 15.6852 11.1267C17.2159 12.6955 19.6976 12.6955 21.2284 11.1267Z",
    fill: "#EC586E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.7275 7.37591L18.6257 6.71948V9.8533",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1592_849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellTrans);
export default __webpack_public_path__ + "static/media/bell_trans.ca77fc6267eb034788b76fe8012be098.svg";
export { ForwardRef as ReactComponent };